const data = {
  id: 1,
  title: 'Unscramble letters to make a completed word.',
  subTitle: 'Sắp xếp lại các chữ cái để có từ đúng.',
  question: 'class',
  answer: 'class',
  settings: {
    question: {
      // shuffedType: 'word',
      shuffedType: 'character',
    },
  },
};

export default data;
